import { LiPostSort, TimeType } from "@/enum/li-post.enum";

import { LiPostType } from "@/enum/liprofile.enum";

/** Default values for a brand-new LiPost form. */
export const initialState = {
	name: "",
	query: "",
	postUrl: "",
	maxPerPost: 100,
	repeatDaily: false,
	sortBy: LiPostSort.DATE_POSTED,
	timeType: TimeType.PERIOD,
	type: LiPostType.BY_TOPIC,
	posts: false,
	commentsToPost: false,
	likesToPost: false,
	commentsToComment: false,
	likesToComment: false,
	plannedScrapingUserId: null,
};

/**
 * Time-frame dropdown options. The 365-day option is only offered when the source is
 * not a tracked profile (profiles are capped at 90 days).
 */
export const getTimeFrameOptions = (type?: LiPostType) => {
	const options = [
		{ title: "last 7 days", id: 7 },
		{ title: "last 14 days", id: 14 },
		{ title: "last 30 days", id: 30 },
		{ title: "last 90 days", id: 90 },
	];

	if (type !== LiPostType.BY_PROFILE) {
		options.push({ title: "last 365 days", id: 365 });
	}

	return options;
};
